import qs from 'qs';

export const FAQ_CATEGORIES = {
  GENERAL_QUERIES: "General Queries"
}

export const getAllFaqCategoriesQs = qs.stringify({
  populate: {
    icon: {
      fields: ['url', 'alternativeText']
    }
  }
})

export const getAllFaqsQs = (crpVersion = "One") => qs.stringify({
  filters: {
    cipCrpType: {
      crpVersionType: { $in: crpVersion }
    }
  },
  pagination: {
    pageSize: 1000
  }
})


export const getFaqFromCategoryQs = (categoryName = FAQ_CATEGORIES.GENERAL_QUERIES, crpVersion = "One") => {
  return qs.stringify({
    filters: {
      faqCategory: {
        title: { $eq: categoryName }
      },
      cipCrpType: {
        crpVersionType: { $in: crpVersion }
      }
    },
    pagination: {
      pageSize: 1000
    }
  })
}